const P = console, U = {
  AUTH: "AUTH",
  LOCATION: "LOCATION",
  LOCATION_REFRESH: "LOCATION_REFRESH",
  SIGNOUT: "SIGNOUT",
  IS_OPEN: "IS_OPEN",
  TOGGLE_CHATBOX: "TOGGLE_CHATBOX",
  REDIRECT_FINARO: "REDIRECT_FINARO",
  OPEN_HELP_MODAL: "OPEN_HELP_MODAL",
  CHANGE_DATA_OWNER: "CHANGE_DATA_OWNER",
  APP_READY: "APP_READY",
  APP_STATE: "APP_STATE"
}, e = "ember_simple_auth-session", D = "authenticator:sso";
function r() {
  var E;
  try {
    const S = localStorage.getItem(e);
    if (!S)
      return null;
    const I = JSON.parse(S);
    return !I.authenticated || Object.keys(I.authenticated).length === 0 ? null : {
      authenticated: {
        authenticator: I.authenticated.authenticator,
        token: I.authenticated.token,
        permissions: I.authenticated.permissions.map((A) => ({
          locationId: A.l,
          permissionId: A.p
        })),
        dataOwnerPermissions: ((E = I.authenticated.dataOwnerPermissions) == null ? void 0 : E.map((A) => ({
          dataOwnerId: A.d,
          permissionIds: A.p,
          relatedDataOwnerIds: A.r,
          locationIds: A.l
        }))) ?? [],
        firstName: I.authenticated.firstName,
        lastName: I.authenticated.lastName,
        email: I.authenticated.email,
        parentUserId: I.authenticated.parentUserId,
        sub: I.authenticated.sub,
        isSSO: I.authenticated.authenticator === D,
        userSince: I.authenticated.userSince,
        exp: I.authenticated.exp,
        aId: I.authenticated.aId,
        iss: I.authenticated.iss,
        jti: I.authenticated.jti,
        is2fa: I.authenticated.is2fa,
        requestor: I.authenticated.requestor,
        isOwner: !I.authenticated.parentUserId
      },
      lastActiveAt: I.lastActiveAt,
      locationId: I.locationId
    };
  } catch (S) {
    return P.warn(`Failed to parse auth data. Reason: ${S.message}`), null;
  }
}
function M(E) {
  try {
    const S = localStorage.getItem(e), I = S ? JSON.parse(S) : {};
    localStorage.setItem(e, JSON.stringify({ ...I, locationId: E }));
  } catch (S) {
    P.warn(`Failed to update auth locationId. Reason: ${S.message}`);
  }
}
const N = {
  GENERAL: {
    LIGHTHOUSE_ACCESS: 10,
    SALES_INFO: 11,
    TICKET_INFO: 12,
    PAYMENT_INFO: 13,
    PROCESSING_DETAIL: 14,
    MONTHLY_CC_STATEMENTS: 15,
    VIEW_1099K: 16,
    ACCOUNT_NOTICES: 17,
    BATCH_HISTORY: 18,
    LABOR_PERCENTAGE: 19,
    EMPLOYEE_TIMECLOCK: 20,
    REPORTS: 21
  },
  OLD_DASHBOARD: {
    SALES_INFO: 11,
    TICKET_INFO: 12,
    PAYMENT_INFO: 13,
    PROCESSING_DETAIL: 14
  },
  DOCUMENTS: {
    MONTHLY_CC_STATEMENTS: 15,
    VIEW_TAX_DOCUMENTS: 16,
    ACCOUNT_NOTICES: 17
  },
  LOCATION_OVERVIEW: {
    BATCH_HISTORY: 18,
    LABOR_PERCENTAGE: 19,
    EMPLOYEE_TIMECLOCK: 20
  },
  REPORTING: {
    REPORTS: 21,
    ACCESS_REPORTING: 113,
    MANAGE_USERS_SUBSCRIPTIONS: 116,
    CREATE_OWN_SUBSCRIPTIONS: 121,
    GIFT_CARDS: 142
  },
  HBR: {
    EMPLOYEES_AND_JOBS: 22,
    MENU: 23,
    ACCOUNTING: 24,
    TABLE_LAYOUT: 25,
    TIMECLOCK: 26,
    ONLINE_ORDERING: 27,
    EMPLOYEE_SCHEDULING: 28,
    RESERVATIONS: 29,
    TABLESIDE: 30,
    PAYMENTS: 45,
    CUSTOMERS: 46
  },
  HOSP: {
    EMPLOYEES: 31,
    MENU: 32,
    ITEM_GROUPS: 33,
    CHOICES_AND_CHOICE_SETS: 34,
    ONLINE_ORDERING: 35,
    RESERVATIONS: 3
  },
  ECHO: {
    POS: 36
  },
  SALON: {
    POS: 38
  },
  ORDERS: {
    PLACE_SUPPLY_ORDER: 39,
    VIEW_SUPPLY_ORDER: 40,
    VIEW_POS_ORDER: 41
  },
  SUPPORT: {
    VIEW_CONTACT_INFO: 42,
    SEND_TICKETS: 43,
    VIEW_DOCS: 44,
    SEND_SUPPORT_MESSAGES: 122
  },
  SOCIAL_MEDIA: {
    MANAGE_ACCOUNTS: 51,
    MANAGE_POSTS: 52
  },
  MARKETPLACE: {
    ACCESS: 60
  },
  REPUTATION_MANAGEMENT: {
    MANAGE_ACCOUNTS: 70,
    MANAGE_REVIEWS: 71
  },
  CUSTOMER_ENGAGEMENT: {
    ACCESS: 75
  },
  PROCESSING: {
    CUSTOMERS: 80
  },
  SKYTAB: {
    ACCESS: 90
  },
  LOYALTY: {
    MANAGE_PROGRAMS: 101,
    MANAGE_DISCOUNTS: 102,
    MANAGE_MEMBERS: 103,
    MANAGE_PROMOTIONS: 104
  },
  DISPUTES: {
    VIEW_DISPUTE: 110,
    SUBMIT_DISPUTE_INFO: 111,
    VIEW_SUBMITTED_INFO: 112
  },
  CONFIGURATION: {
    MANAGE_SETTINGS: 114
  },
  USERS: {
    MANAGE_USERS: 115,
    GRANT_MANAGE_USERS: 117
  },
  IN_CHARGE_APP: {
    ACCESS_LIGHTHOUSE_MOBILE_APP: 120
  },
  TRANSACTIONS: {
    VIEW_TRANSACTIONS: 123,
    CREATE_TRANSACTIONS: 124,
    REFUND_TRANSACTIONS: 125
  },
  DASHBOARD: {
    VIEW_DASHBOARD: 126
  },
  RISK: {
    MANAGE_BLOCK_LISTS: 127,
    VIEW_RISK_RULES: 128,
    MANAGE_RISK_RULES: 129
  },
  DEVELOPERS: {
    MANAGE_DEVELOPER_SETTINGS: 130
  },
  INTERNET_PAYMENTS_DISPUTES: {
    IP_VIEW_DISPUTES: 131,
    IP_SUBMIT_DISPUTE_EVIDENCE: 132
  },
  INSIGHTS: {
    VIEW_AUTH: 133,
    VIEW_RISK: 134,
    VIEW_CARD_VERIFY: 135,
    VIEW_CHARGEBACK: 136
  },
  BUSINESS_SETTINGS: {
    MANAGE_DAY_PARTS_AND_REVENUE_CENTERS: 137
  },
  FINARO: {
    FINARO_INSIGHT_ACCESS: 139
  },
  GIFT_CARDS: {
    ACCESS: 140,
    ORDERS_ACCESS: 141
  },
  INVOICES: {
    VIEW_INVOICES: 143
  },
  SETTINGS: {
    MANAGE_BUSINESS_SETTINGS: 146,
    GRANT_BUSINESS_SETTINGS_MANAGEMENT: 147
  },
  PUBLICATION: {
    ALLOW_PUBLISH: 148
  }
}, s = [
  N.DOCUMENTS.MONTHLY_CC_STATEMENTS,
  N.DOCUMENTS.VIEW_TAX_DOCUMENTS,
  N.DOCUMENTS.ACCOUNT_NOTICES,
  N.REPORTING.REPORTS,
  N.REPORTING.CREATE_OWN_SUBSCRIPTIONS,
  N.SUPPORT.VIEW_CONTACT_INFO,
  N.SUPPORT.SEND_SUPPORT_MESSAGES,
  N.USERS.MANAGE_USERS,
  N.USERS.GRANT_MANAGE_USERS,
  N.TRANSACTIONS.VIEW_TRANSACTIONS,
  N.TRANSACTIONS.CREATE_TRANSACTIONS,
  N.TRANSACTIONS.REFUND_TRANSACTIONS,
  N.DASHBOARD.VIEW_DASHBOARD,
  N.RISK.MANAGE_BLOCK_LISTS,
  N.RISK.VIEW_RISK_RULES,
  N.RISK.MANAGE_RISK_RULES,
  N.DEVELOPERS.MANAGE_DEVELOPER_SETTINGS,
  N.INTERNET_PAYMENTS_DISPUTES.IP_VIEW_DISPUTES,
  N.INTERNET_PAYMENTS_DISPUTES.IP_SUBMIT_DISPUTE_EVIDENCE,
  N.INSIGHTS.VIEW_AUTH,
  N.INSIGHTS.VIEW_RISK,
  N.INSIGHTS.VIEW_CARD_VERIFY,
  N.INSIGHTS.VIEW_CHARGEBACK,
  N.SETTINGS.MANAGE_BUSINESS_SETTINGS,
  N.SETTINGS.GRANT_BUSINESS_SETTINGS_MANAGEMENT
];
var C = /* @__PURE__ */ ((E) => (E.FuturePOS = "futurepos", E.POSitouch = "positouch", E.RestaurantManager = "rmpos", E.Shift4 = "shift4", E.Harbortouch = "harbortouch", E.Slice = "slice", E))(C || {}), t = /* @__PURE__ */ ((E) => (E.CA = "CA", E.GB = "GB", E.LT = "LT", E.PR = "PR", E.US = "US", E.VI = "VI", E))(t || {}), a = /* @__PURE__ */ ((E) => (E.SOCIAL_SCHEDULES = "social-schedules", E.ONLINE_ORDERING = "online-ordering", E.RESERVATIONS = "reservations", E.LIGHTHOUSE_PREMIUM = "lighthouse-premium", E.FINARO_INSIGHT = "finaro-insight", E.GIFT_CARDS = "gift-cards", E.CHARGE_ZOOM = "charge-zoom", E.LBM2 = "lbm2", E.MATTERHORN = "matterhorn-api", E))(a || {}), i = /* @__PURE__ */ ((E) => (E.ECHO_PRO = "echo-pro", E.TERMINAL = "terminal", E.SALON = "salon", E.MOZART = "mozart", E.HOSPITALITY = "hospitality", E.ECHO = "echo", E.RETAIL = "retail", E.INTERNET_PAYMENTS = "internet-payments", E.GPATT = "gpatt", E.KDS = "kds", E))(i || {}), L = /* @__PURE__ */ ((E) => (E.APPROVED = "APPROVED", E.PENDING = "PENDING", E.BLOCKED = "BLOCKED", E.UNKNOWN = "UNKNOWN", E))(L || {}), _ = /* @__PURE__ */ ((E) => (E[E.PRE_APPLICATION_RECEIVED = 100] = "PRE_APPLICATION_RECEIVED", E[E.RESUBMITTED_APPLICATION = 125] = "RESUBMITTED_APPLICATION", E[E.DECLINED = 200] = "DECLINED", E[E.CLOSED_MERCHANT_CANCELLED = 300] = "CLOSED_MERCHANT_CANCELLED", E[E.CLOSED_TERMINATION = 325] = "CLOSED_TERMINATION", E[E.SEASONAL_BUSINESS = 330] = "SEASONAL_BUSINESS", E[E.GATEWAY_OR_ACCESSORY_SERVICE_ONLY = 350] = "GATEWAY_OR_ACCESSORY_SERVICE_ONLY", E[E.AWAITING_ISO_ACTIVATION_OF_UNDERWRITING = 375] = "AWAITING_ISO_ACTIVATION_OF_UNDERWRITING", E[E.ORIG_APP_RECEIVED_IN_UNDERWRITING = 390] = "ORIG_APP_RECEIVED_IN_UNDERWRITING", E[E.IN_UNDERWRITING = 400] = "IN_UNDERWRITING", E[E.ON_PRIMARY_HOLD_NEED_ADDITIONAL_INFORMATION = 425] = "ON_PRIMARY_HOLD_NEED_ADDITIONAL_INFORMATION", E[E.APPROVED_IN_DATA_ENTRY_FOR_MID_BUILD = 500] = "APPROVED_IN_DATA_ENTRY_FOR_MID_BUILD", E[E.APPROVED_AWAITING_FAXED_DOCUMENTATION = 550] = "APPROVED_AWAITING_FAXED_DOCUMENTATION", E[E.APPROVED = 600] = "APPROVED", E[E.APPROVED_INSTALLED = 650] = "APPROVED_INSTALLED", E[E.MERCHANT_REQUESTING_TO_CANCEL = 675] = "MERCHANT_REQUESTING_TO_CANCEL", E[E.APPROVED_PROCESSING = 700] = "APPROVED_PROCESSING", E[E.APPROVED_SEASONAL_HOLD = 730] = "APPROVED_SEASONAL_HOLD", E[E.LEGAL_REVIEW = 785] = "LEGAL_REVIEW", E))(_ || {});
const n = Object.freeze([
  _.PRE_APPLICATION_RECEIVED,
  _.RESUBMITTED_APPLICATION,
  _.AWAITING_ISO_ACTIVATION_OF_UNDERWRITING,
  _.ORIG_APP_RECEIVED_IN_UNDERWRITING,
  _.IN_UNDERWRITING,
  _.ON_PRIMARY_HOLD_NEED_ADDITIONAL_INFORMATION,
  _.APPROVED_IN_DATA_ENTRY_FOR_MID_BUILD,
  _.APPROVED_AWAITING_FAXED_DOCUMENTATION
]), h = Object.freeze([
  _.SEASONAL_BUSINESS,
  _.APPROVED,
  _.APPROVED_INSTALLED,
  _.MERCHANT_REQUESTING_TO_CANCEL,
  _.APPROVED_PROCESSING,
  _.APPROVED_SEASONAL_HOLD,
  _.LEGAL_REVIEW
]), l = Object.freeze([
  _.DECLINED,
  _.CLOSED_MERCHANT_CANCELLED,
  _.CLOSED_TERMINATION
]), V = "launch-control-v1", R = {
  development: "development",
  staging: "staging",
  production: "production"
}, H = (E) => Object.values(R).includes(E) ? E : R.development, p = {
  [R.production]: {
    lhApiHost: "https://lighthouse-api.harbortouch.com",
    steAPiHost: "https://skytab-enterprise.prod.lh.shift4payments.com",
    launchDarkly: {
      clientSideId: "614022e9694e8d262b59f82f",
      stposClientSideId: "5fe60cb26004d70ada453ead"
    }
  },
  [R.staging]: {
    lhApiHost: "https://lighthouse-api-staging.harbortouch.com",
    steAPiHost: "https://skytab-enterprise.stage.lh.shift4payments.com",
    launchDarkly: {
      clientSideId: "62695639cb0596159e560770",
      stposClientSideId: "607097c3eb9c070ca166678a"
    }
  },
  [R.development]: {
    steAPiHost: "https://skytab-enterprise.dev.lh.shift4payments.com",
    lhApiHost: "http://localhost:9000",
    launchDarkly: {
      clientSideId: "62695639cb0596159e560770",
      stposClientSideId: "607097c3eb9c070ca166678a"
    }
  }
}, W = (E) => {
  const S = {}, I = [];
  for (const T of E) {
    const O = {
      id: T.id,
      name: T.name,
      heading: T.legalName ?? "",
      merchantId: T.merchantId
    };
    T.shift4Serial ? S[T.shift4Serial] ? S[T.shift4Serial].push(O) : S[T.shift4Serial] = [O] : I.push(O);
  }
  const A = {};
  for (const [T, O] of Object.entries(S))
    A[O[0].heading] ? A[O[0].heading].push(...O) : A[O[0].heading] = O;
  return {
    categorized: Object.keys(A).sort().reduce((T, O) => (T[O] = A[O], T), {}),
    uncategorized: I
  };
};
export {
  U as APPLICATION_EVENT,
  h as APPROVED_ACCOUNT_STATUSES,
  D as AUTHENTICATOR_SSO,
  L as AccountStatus,
  _ as AccountStatusCode,
  l as BLOCKED_ACCOUNT_STATUSES,
  C as BrandNames,
  t as CountryCode,
  R as ENVIRONMENT,
  p as ENVIRONMENT_CONFIG,
  s as INTERNET_PAYMENT_PERMISSIONS,
  V as LAUNCH_CONTROL_DEFAULT_WORKFLOW_NAME,
  e as LOCAL_STORAGE_AUTH_KEY,
  a as LocationService,
  n as PENDING_ACCOUNT_STATUSES,
  N as PERMISSIONS,
  i as Product,
  W as createLocationGroups,
  r as getAuth,
  H as getValidEnvironment,
  P as logger,
  M as updateAuthLocationId
};
